import { ButtonPrimary, ErrorFeedbackScreen, InfoFeedbackScreen } from '@telefonica/mistica';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './index.scss';
import { TrackingEvents } from '../../../../utils/dataTransformation/tracking';
import { isWebviewAndroid, isWebviewIOS } from '../../../../utils/navigation/controlDevices';

const AvailableBonusMessage: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const [params] = useSearchParams();

    const { trackingScreenView } = new TrackingEvents();
    useEffect(() => {
        if (!(isWebviewAndroid || isWebviewIOS)) {
            trackingScreenView();
        }
    }, []);
    const setFeedback = (type: string) => {
        if (type === 'SUCCESS') {
            return (
                <div className='availableBonusMessage-page__info'>
                    <InfoFeedbackScreen
                        title={t('infoFeedbackScreenTitle')}
                        description={t('infoFeedbackScreenDescription')}
                        primaryButton={
                            <ButtonPrimary onPress={() => navigate('/home')}>
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                    />
                </div>
            );
        }

        if (type === 'ERROR') {
            return (
                <div className='availableBonusMessage-page__error'>
                    <ErrorFeedbackScreen
                        title={t('errorFeedbackScreenTitle')}
                        description={t('errorFeedbackScreenDescription')}
                        primaryButton={
                            <ButtonPrimary onPress={() => navigate('/home')}>
                                {t('buttonUnderstoodFeedback')}
                            </ButtonPrimary>
                        }
                        errorReference='Error reference: #95001'
                    />
                </div>
            );
        }
    };

    return <div className='availableBonusMessage-page'>{setFeedback(params.get('type')!)}</div>;
};

export default AvailableBonusMessage;
